// extracted by mini-css-extract-plugin
export default {"container":"EmailTemplateManager_container__6HRCx","editor":"EmailTemplateManager_editor__t8UuK","loading":"EmailTemplateManager_loading__nK2bo"};